import { Form, Modal, Input, DatePicker, TimePicker, Alert } from "antd";
import { useState } from "react";
import { ScheduleDetails } from "../../serviceoperation/entity/ScheduleOperationEntity";
import dayjs from "dayjs";
import { ScheduleOperation } from "../../serviceoperation/ScheduleOperation";

interface EditScheduleFormProps {
  open: boolean;
  onCreate: (values: ScheduleDetails) => void;
  onCancel: () => void;
  scheduleDetails: ScheduleDetails;
  cropId: number;
}

//AddScheduleForm
const EditScheduleForm: React.FC<EditScheduleFormProps> = ({
  open,
  onCreate,
  onCancel,
  scheduleDetails,
  cropId,
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showWarning, setWarning] = useState(false);

  const format = "hh:mm A";

  console.log(scheduleDetails);
  const [form] = Form.useForm();
  const rangeConfig = {
    rules: [
      {
        type: "array" as const,
        required: true,
        message: "Please select time!",
      },
    ],
  };

  const patchSchedule = async (values: any): Promise<boolean> => {
    const scheduleOps = new ScheduleOperation();
    let success = false;
    const scheduleDate = new Date(values.scheduleDate.toDate());
    scheduleDate.setHours(0, 0, 0, 0);
    await scheduleOps
      .putScheduleAsync(cropId, scheduleDetails.scheduleID, {
        WorkDay: scheduleDate,
        StartWorkHour: dayjs(values.scheduleTime[0]).hour(),
        StartWorkMinute: dayjs(values.scheduleTime[0]).minute(),
        EndWorkHour: dayjs(values.scheduleTime[1]).hour(),
        EndWorkMinute: dayjs(values.scheduleTime[1]).minute(),
      })
      .then((x) => {
        success = x.status === 204;
      });

    return success;
  };

  return (
    <Modal
      open={open}
      title="Edit Schedule"
      okText="Update"
      cancelText="Cancel"
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      onOk={() => {
        // Before we test the form, we need to
        // make sure selected Employee does not have
        // TimeOff Request.
        setConfirmLoading(true);
        form
          // Validate the required fields.
          .validateFields()
          .then(async (values) => {
            console.log(values);
            // Insert Employee Schedule..
            // This is where you insert Schedule
            // and then return to Parent Component. :)
            if (await patchSchedule(values)) {
              form.resetFields();
              onCreate(values);
            } else {
              setShowError(true);
              // Stay on the Page and keep the Modal open and display Error message.
            }
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
        setConfirmLoading(false);
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={{ modifier: "public" }}
      >
        <Form.Item
          name="title"
          label="Title"
          initialValue={scheduleDetails.title}
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Schedule Date Time" style={{ marginBottom: 12 }}>
          <Form.Item
            name="scheduleDate"
            initialValue={
              scheduleDetails?.workDate ? dayjs(scheduleDetails.workDate) : null
            } // Inline initialValue
            rules={[
              {
                required: true,
                message: "Please select date",
              },
            ]}
            style={{
              display: "inline-block",
              width: "calc(33% - 8px)",
              margin: "0 4px",
            }}
          >
            <DatePicker
              value={
                scheduleDetails?.workDate
                  ? dayjs(scheduleDetails.workDate)
                  : null
              } // Pass Date object to dayjs()
              //onSelect={handleSelectedDateChange}
              format="YYYY-MM-DD"
            />
          </Form.Item>
          <Form.Item
            name="scheduleTime"
            initialValue={[
              // Start Time: combine startWorkHour and startWorkMinutes
              scheduleDetails?.startWorkHour !== undefined &&
              scheduleDetails?.startWorkMinute !== undefined
                ? dayjs()
                    .hour(scheduleDetails.startWorkHour)
                    .minute(scheduleDetails.startWorkMinute)
                    .second(0)
                : null, // Default to null if undefined

              // End Time: combine endWorkHour and endWorkMinutes
              scheduleDetails?.endWorkHour !== undefined &&
              scheduleDetails?.endWorkMinute !== undefined
                ? dayjs()
                    .hour(scheduleDetails.endWorkHour)
                    .minute(scheduleDetails.endWorkMinute)
                    .second(0)
                : null, // Default to null if undefined
            ]}
            {...rangeConfig}
            style={{
              display: "inline-block",
              //width: "calc(33% - 8px)",
              margin: "0 4px",
            }}
          >
            <TimePicker.RangePicker minuteStep={5} format={format} />
          </Form.Item>
        </Form.Item>
        <Form.Item
          name="note"
          label="Notes"
          initialValue={scheduleDetails.note}
        >
          <Input.TextArea showCount maxLength={255} />
        </Form.Item>
      </Form>
      {showError ? (
        <Alert
          message={
            "There was an error processing your request. Please try again later."
          }
          type="error"
          showIcon
        />
      ) : null}
      {showWarning ? (
        <Alert
          message={
            "The chosen employee's preference does not align with the schedule's specifications"
          }
          type="warning"
          showIcon
        />
      ) : null}
    </Modal>
  );
};

export default EditScheduleForm;
